module.exports = __webpack_public_path__ + "img/laptop-icon.3b1226fb.svg";